export default "__VITE_ASSET__HzkcZFJRXJPUL564a2jhnA__"